/**
 * Papel da afiliação de teleconsultoria (OrganizationAffiliation.code).
 *
 * - `organization` = prestadora da teleconsultoria.
 * - `participatingOrganization` = receptora do serviço.
 *
 * Usa o mesmo system dos convênios (code `provider`), mas com o code `HIE/HIO`.
 * É o code que separa os dois fluxos: convênio nunca usa `HIE/HIO`.
 */
export const ORGANIZATION_ROLE_SYSTEM =
  "http://terminology.hl7.org/CodeSystem/organization-role";

/**
 * System canônico do FHIR R5 para o mesmo CodeSystem.
 * Só é aceito na leitura, para registros gravados por outra integração.
 */
export const ORGANIZATION_ROLE_SYSTEM_R5 =
  "http://hl7.org/fhir/organization-role";

export const TELECONSULTORIA_AFFILIATION_ROLE = {
  system: ORGANIZATION_ROLE_SYSTEM,
  code: "HIE/HIO",
  display: "HIE/HIO",
} as const;

/** Texto do `code` gravado na afiliação (leitura humana no FHIR). */
export const TELECONSULTORIA_AFFILIATION_CODE_TEXT = "Teleconsultoria";

/**
 * Pedido de afiliação feito pela AFILIADA (ela escolheu a prestadora).
 * A afiliação nasce inativa com esta extension = "pending" até a prestadora aprovar:
 * sem aprovação, qualquer clínica veria os teleconsultores e horários de outra.
 */
export const AFFILIATION_REQUEST_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/teleconsultoria-affiliation-request";
export const AFFILIATION_REQUEST_PENDING = "pending";

/** Identifier do Contract da extensão (mesmo de `TeleconsultoriaContractContext`). */
export const TELECONSULTORIA_CONTRACT_IDENTIFIER = "teleconsultoria";

/** Valor de `?tab=` que abre a aba de afiliações na página de Teleconsultoria. */
export const TELECONSULTORIA_AFFILIATIONS_TAB = "afiliacoes";
